import Joi from 'joi'
import { format } from "date-fns";


export const FORM_FIELD_KEYS = {
  CLIENT_NAME: "clientName",
  DIRECTED_TO: "directedTo",
  CLIENT_CODE: 'clientCode',
  CLIENT_INDUSTRY: "clientIndustry",
  CLIENT_TYPE: "clientType",
  CONTACT_EMAILS: "contactEmails",
  PANEL_DASHBOARD_LINK: "panelDashboardLink",
  SALES_POC: "salesPoc",
  PRICING_MATRIX: "pricingMatrix",
  LINK1: 'link1',
  LINK2: 'link2',
  LINK3: 'link3',
  PRICING_MODEL_B2B: "",
  PRICING_MODEL_B2C: "",
  PRICING_MODEL_HIGH_NET: "",
  PRICING_MODEL_HEALTHCARE: "",
  PRICING_MODEL_GOVT_OFFICIALS: "",
  REGION: "region",
  COUNTRY: "country",
  CIP_VERSION: "cip_version",
  HAVE_A_QUOTE: "have_a_quote",
  CRP_VERSION: "crp_version"
}


export const PRICING_MODEL_TYPE = {
  DEFAULT: "default",
  CUSTOM: "custom"
}

export const CIP_ACCESS_CONTROL_OPTIONS = [
  {
    label: "Whole CIP",
    value: "CIP"
  },
  {
    label: "Onboarding Link Only",
    value: "onboarding"
  },
  {
    label: "TaaS estimate Only",
    value: "only_taas"
  },
  {
    label: "Onboarding Link only (without NDA, SLA/MSA forms)",
    value: "onboarding_only_without_forms"
  }
]

export const CIP_ACCESS_CONTROL = {
  CIP: "Whole CIP",
  onboarding: "Onboarding",
  only_taas: "Show Taas",
}

export const ONBOARDING_CONTROL_VALUES = {
  onboarding_with_forms: "Onboarding With NDA, SLA/MSA forms",
  onboarding_without_forms: "Onboarding Without NDA, SLA/MSA forms",
  onboarding_with_nda: "Onboarding with NDA form only"
}

const directedToRegex = /^@/i


export const clientSchema = Joi.object({
  [FORM_FIELD_KEYS.CLIENT_NAME]: Joi.string().label('Client Name').required().trim().messages({
    "string.pattern.base": "\"Client Name\" is required"
  }),
  [FORM_FIELD_KEYS.CLIENT_CODE]: Joi.string().label('Client Code').required().min(3).max(7).trim().messages({
    "string.pattern.base": "\"Client Code\" is required"
  }),
  [FORM_FIELD_KEYS.DIRECTED_TO]: Joi.string().label('Directed To').required().regex(directedToRegex).min(4).trim().messages({
    "string.pattern.base": "\"Directed To\" must start with \"@\""
  }),
  [FORM_FIELD_KEYS.CLIENT_TYPE]: Joi.string().label('Client Type').required().messages({
    "string.pattern.base": "\"Client Type\" is required"
  }),
  [FORM_FIELD_KEYS.CLIENT_INDUSTRY]: Joi.string().label('Industry').required().messages({
    "string.pattern.base": "\"Industry\" is required"
  }),
  [FORM_FIELD_KEYS.REGION]: Joi.object().label('Region').required().messages({
    "object.base": "\"Region\" is required",
    "object.empty": "\"Region\" is required"
  }),
  [FORM_FIELD_KEYS.CIP_VERSION]: Joi.string().label('CIP Version').required().messages({
    "string.pattern.base": "\"CIP Version\" is required"
  }),
  [FORM_FIELD_KEYS.CRP_VERSION]: Joi.string().label('CRP Version').required().messages({
    "string.pattern.base": "\"CRP Version\" is required"
  }),
  [FORM_FIELD_KEYS.PANEL_DASHBOARD_LINK]: Joi.string().uri().label('Panel Dashboard').optional().allow("").messages({
    "string.pattern.base": "\"Panel Dashboard link\" is required"
  }),
  [FORM_FIELD_KEYS.SALES_POC]: Joi.string().label('Sales POC').required().messages({
    "string.pattern.base": "\"Sales POC\" is required"
  }),
  [FORM_FIELD_KEYS.COUNTRY]: Joi.object().label('Country').required().messages({
    "object.base": "\"Country\" is required",
  }),
  [FORM_FIELD_KEYS.CONTACT_EMAILS]: Joi.array().items(

    Joi.string().email({ tlds: { allow: false } }).label("Email").required().messages({
      "string.pattern.base": "\"Email\" must be a valid Email ID"
    })

  ).min(1).label('Contact Emails').required().messages({
    "string.pattern.base": "\"Contact Emails\" is required"
  }),
})

export const CLIENT_PRICING_TIER = {
  BASIC: "basic",
  STANDARD: "standard",
  PREMIUM: "premium"
}

export const displayPreviousAccessControlValues = (prevValues) => {
  let updatedPrevValues = []
  for (let i = 0; i < prevValues?.length; i++) {
    if (prevValues[i] !== null) {
      updatedPrevValues.push(`${i + 1}. ${CIP_ACCESS_CONTROL[prevValues[i]?.prevValue]} ( ${prevValues[i]?.prevVersion} - ${prevValues[i]?.createdAt && format(new Date(prevValues[i]?.createdAt), "dd MMM yy")})`)
    }
  }
  return updatedPrevValues
}
